<div class="search-box">
  <input
    type="text"
    [(ngModel)]="searchTerm"
    (keyup.enter)="onSearch()"
    placeholder="{{ placeholder }}"
  />
  <button (click)="onSearch()">{{ buttonLabel }}</button>
</div>
